<ng-container *ngIf="hasSupportedPaymentRuleTypes">
  <div
    class="gw-mt-6 gw-border-base gw-bg-background-elevation-2 md:gw-rounded-2xl"
  >
    <div
      class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-neutral-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-px-4 md:gw-px-6"
    >
      <p class="gw-text-[16px] gw-text-text-primary gw-font-bold">
        {{ 'common.paymentRules.title' | translate }}
      </p>
    </div>

    <div
      [formGroup]="paymentFormController"
      class="gw-pt-[24px] gw-pl-[24px] gw-flex gw-items-center gw-gap-[8px]"
    >
      <p class="gw-form-label">
        {{ 'common.paymentRules.ruleTypesLabel' | translate }}
      </p>

      <gatewee-checkbox
        *ngIf="allowedRuleTypes.bankSlip"
        [label]="'common.paymentRules.checkboxBankSlipSlipix' | translate"
        formControlName="ticket"
      ></gatewee-checkbox>

      <gatewee-checkbox
        *ngIf="mode === 'checkout' && allowedRuleTypes.creditCard"
        [label]="'common.paymentRules.checkboxCredit' | translate"
        formControlName="creditCard"
      ></gatewee-checkbox>
    </div>

    <ng-container *ngIf="!emptyPaymentRules; else emptyRules">
      <!-- Bank Slip Rules -->
      <div
        *ngIf="paymentFormController.get('ticket')?.value"
        class="gw-border-base gw-flex gw-flex-col md:gw-flex-row gw-gap-[16px] gw-items-center gw-bg-background-neutral-1 md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
      >
        <div class="gw-flex gw-flex-col gw-items-center gw-w-full">
          <div class="gw-flex gw-items-center gw-mb-6 gw-gap-[8px] gw-w-full">
            <span class="gw-section-divider-line"></span>
            <span
              class="gw-text-[14px] gw-color-[#62748E] gw-leading-[20px] gw-mr-2"
              >{{
                'common.paymentRules.sectionBankSlipSlipix' | translate
              }}</span
            >
            <span class="gw-section-divider-extender"></span>
          </div>
          <form
            [formGroup]="bankSlipForm"
            class="gw-w-full gw-flex gw-flex-col gw-gap-small"
          >
            <div
              class="gw-w-full gw-flex gw-flex-col md:gw-flex-row gw-items-center md:gw-gap-[24px]"
            >
              <gatewee-input-v2
                class="gw-w-full"
                [form]="fineForm"
                [label]="'common.paymentRules.latePaymentFee' | translate"
                controlName="value"
                type="currency"
                [placeholder]="
                  'common.paymentRules.placeholderCurrencyExample' | translate
                "
                [switch]="true"
                (currencyChange)="onCurrencyToggle('fine', $event)"
                [format]="fineIsCurrency ? 'currency' : 'percent'"
                [customMessages]="
                  fineIsCurrency ? {} : interestPercentCustomMessages
                "
              ></gatewee-input-v2>
              <gatewee-input-v2
                class="gw-w-full"
                [form]="interestForm"
                [label]="'common.paymentRules.interestDue' | translate"
                controlName="value"
                type="currency"
                [placeholder]="
                  'common.paymentRules.placeholderCurrencyExample' | translate
                "
                [switch]="true"
                (currencyChange)="onCurrencyToggle('interest', $event)"
                [format]="interestIsCurrency ? 'currency' : 'percent'"
                [customMessages]="
                  interestIsCurrency ? {} : interestPercentCustomMessages
                "
              ></gatewee-input-v2>
            </div>
            <div
              formGroupName="discount"
              class="gw-w-full gw-flex gw-flex-col md:gw-flex-row gw-items-center md:gw-gap-[24px]"
            >
              <gatewee-input-v2
                class="gw-w-full"
                [form]="discountForm"
                [label]="'common.paymentRules.discount' | translate"
                controlName="value"
                type="currency"
                iconName="@tui.ticket-percent"
                [placeholder]="
                  'common.paymentRules.placeholderDiscount' | translate
                "
                [switch]="true"
                (currencyChange)="onCurrencyToggle('discount', $event)"
                [format]="discountIsCurrency ? 'currency' : 'percent'"
                [customMessages]="
                  discountIsCurrency ? {} : interestPercentCustomMessages
                "
              ></gatewee-input-v2>
              <gatewee-datepicker-v2
                class="gw-w-full"
                formControlName="untilDate"
                [label]="'common.paymentRules.discountDueDate' | translate"
                [minDate]="minDate"
              ></gatewee-datepicker-v2>
            </div>
            <div
              class="gw-flex gw-w-full gw-flex-col md:gw-flex-row gw-text-center md:gw-text-left gw-items-center gw-gap-[4px]"
            >
              <i class="fa-solid fa-circle-info gw-text-[#2B7FFF]"></i>
              <p class="gw-text-text-secondary gw-text-[12px]">
                {{ 'common.paymentRules.hintBankSlipSlipix' | translate }}
              </p>
            </div>
          </form>
        </div>
      </div>

      <!-- Credit Card Rules -->
      <div
        *ngIf="paymentFormController.get('creditCard')?.value"
        class="gw-border-base gw-flex gw-flex-col md:gw-flex-row gw-gap-[16px] gw-items-center gw-bg-background-neutral-1 md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
      >
        <div class="gw-flex gw-flex-col gw-items-center gw-w-full">
          <div class="gw-flex gw-items-center gw-mb-6 gw-gap-[8px] gw-w-full">
            <span class="gw-section-divider-line"></span>
            <span
              class="gw-text-[14px] gw-color-[#62748E] gw-leading-[20px] gw-mr-2"
              >{{ 'common.paymentRules.sectionCredit' | translate }}</span
            >
            <span class="gw-section-divider-extender"></span>
          </div>
          <form
            [formGroup]="creditCardForm"
            class="gw-w-full gw-flex md:gw-flex-row gw-flex-col md:gw-gap-x-large"
          >
            <gatewee-select-v3
              class="gw-w-full"
              [label]="'common.paymentRules.maxInstallments' | translate"
              id="maxInstallments"
              [items]="maxInstallments"
              formControlName="maxInstallments"
              [placeholder]="
                'common.paymentRules.selectInstallment' | translate
              "
            ></gatewee-select-v3>
            <gatewee-select-v3
              class="gw-w-full"
              [label]="'common.paymentRules.noInterestUpTo' | translate"
              id="noInterestUpTo"
              [items]="maxInstallments"
              formControlName="noInterestUpTo"
              [placeholder]="
                'common.paymentRules.selectInstallment' | translate
              "
            ></gatewee-select-v3>
            <gatewee-input-v2
              class="gw-w-full"
              [form]="creditCardForm"
              controlName="minPerInstallment"
              [label]="'common.paymentRules.minInstallmentAmount' | translate"
              type="currency"
              [placeholder]="
                'common.paymentRules.placeholderEnterAmount' | translate
              "
              iconName="@tui.circle-dollar-sign"
            ></gatewee-input-v2>
          </form>
          <div
            class="gw-flex gw-w-full gw-flex-col md:gw-flex-row gw-text-center md:gw-text-left gw-items-center gw-gap-[4px]"
          >
            <i class="fa-solid fa-circle-info gw-text-[#2B7FFF]"></i>
            <p class="gw-text-text-secondary gw-text-[12px]">
              {{ 'common.paymentRules.hintCreditCard' | translate }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>

    <span class="gw-mx-x-large gw-flex gw-section-divider-extender"></span>

    <div
      class="gw-p-x-large gw-gw-block md:gw-flex gw-items-center gw-gap-2x-small"
    >
      <strong class="gw-text-text-primary">{{
        'common.paymentRules.legend' | translate
      }}</strong>
      <p class="gw-flex gw-items-center gw-text-text-secondary gw-gap-[6px]">
        <gatewee-icon icon="@tui.ticket-percent" size="16px"></gatewee-icon>
        {{ 'common.paymentRules.percent' | translate }}
      </p>
      <p class="gw-flex gw-items-center gw-text-text-secondary gw-gap-[6px]">
        <gatewee-icon icon="@tui.circle-dollar-sign" size="16px"></gatewee-icon>
        {{ 'common.paymentRules.fixedValue' | translate }}
      </p>
    </div>

    <ng-template #emptyRules>
      <div
        class="gw-content gw-border-base gw-flex gw-flex-col md:gw-flex-row gw-gap-[16px] gw-items-center gw-bg-background-neutral-1 md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px]"
      >
        <gatewee-icon
          icon="@tui.info"
          iconStyle="outline"
          size="24px"
        ></gatewee-icon>
        <div class="gw-col">
          <p class="gw-text-text-primary gw-text-[16px] gw-font-bold">
            {{ 'common.paymentRules.emptyTitle' | translate }}
          </p>
          <p class="gw-text-text-secondary">
            {{ 'common.paymentRules.emptyHint' | translate }}
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
